import React, { useState, useEffect } from "react";
import { CopilotKit } from "@copilotkit/react-core";
import { CopilotPopup } from "@copilotkit/react-ui";
import "@copilotkit/react-ui/styles.css";
import { BUSINESS_SHEET_COPILOT_CONFIG } from "../../constants/copilotConfig";
import MessagePersistenceManager from "./MessagePersistenceManager";
import IMEInputHandler from "./IMEInputHandler";
import { useAiSettings } from "../../contexts/AiSettingsContext";

const CopilotLayout = ({ children, businessSheetData, updateBusinessSheetData }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(BUSINESS_SHEET_COPILOT_CONFIG.defaultOpen);
  // Issue #72: 単一の Context から取得する（取得中・取得失敗はいずれも false）
  const { aiEnabled } = useAiSettings();

  useEffect(() => {
    if (isPopupOpen) {
      document.documentElement.style.setProperty('--button-display', 'none');
    } else {
      document.documentElement.style.setProperty('--button-display', 'block');
    }
  }, [isPopupOpen]);

  const childrenWithProps = React.Children.map(children, (child) =>
    React.isValidElement(child)
      ? React.cloneElement(child, { businessSheetData, updateBusinessSheetData })
      : child
  );

  return (
    <div
      style={{
        "--copilot-kit-primary-color": "#000000",
        "--copilot-kit-contrast-color": "#FFFFFF",
        "--copilot-kit-secondary-contrast-color": "#000000",
        "--copilot-kit-background-color": "#FFFFFF",
        "--copilot-kit-separator-color": "#F6F7F7",
      }}
    >
      {aiEnabled ? (
        <CopilotKit runtimeUrl={BUSINESS_SHEET_COPILOT_CONFIG.runtimeUrl}>
          <MessagePersistenceManager />
          <IMEInputHandler />

          {childrenWithProps}

          <CopilotPopup
            instructions={BUSINESS_SHEET_COPILOT_CONFIG.instructions}
            defaultOpen={BUSINESS_SHEET_COPILOT_CONFIG.defaultOpen}
            labels={BUSINESS_SHEET_COPILOT_CONFIG.labels}
            hideButton={BUSINESS_SHEET_COPILOT_CONFIG.hideButton}
            clickOutsideToClose={BUSINESS_SHEET_COPILOT_CONFIG.clickOutsideToClose}
            hitEscapeToClose={BUSINESS_SHEET_COPILOT_CONFIG.hitEscapeToClose}
            onSetOpen={setIsPopupOpen}
          />
        </CopilotKit>
      ) : (
        childrenWithProps
      )}
    </div>
  );
};

export default CopilotLayout;
